import { isNil } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { colors, Text } from '../../globalStyles';
import { IconButton } from '../Buttons';
import { Icon } from '../Icons';

type UploadProgressProps = {
  progress?: number;
  fileName?: string;
  onAbandon?: () => void;
  onCancel?: () => void;
};

export const UploadProgress = ({
  progress,
  fileName,
  onAbandon,
  onCancel,
}: UploadProgressProps) => {
  if (isNil(progress)) return null;
  const normalized = Math.min(Math.max(progress, 0), 100);
  return (
    <div className="mv3">
      {normalized < 100 ? (
        <>
          <div className="mb2 flex flex-row items-center">
            <Icon icon="iconsTickedLoaderSvg" alt="Loader" className="mr2" />
            {fileName && <Text.bodySmallGrey className="truncate b">{fileName}</Text.bodySmallGrey>}
            {onCancel && (
              <CancelLink type="button" onClick={onCancel}>
                Cancel
              </CancelLink>
            )}
          </div>
          <ProgressContainer
            role="progressbar"
            aria-label={fileName ? `Uploading ${fileName}` : 'Upload progress'}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={normalized}
          >
            <Progress progress={normalized} />
          </ProgressContainer>
        </>
      ) : (
        <div className="mb2 flex flex-row justify-between items-center">
          <div className="nowrap overflow-hidden flex flex-row" style={{ flex: 1 }}>
            <Icon icon="iconsCircleCheckSvg" className="mr2" alt="Upload Complete" />
            {fileName && <Text.bodySmall className="truncate b">{fileName}</Text.bodySmall>}{' '}
          </div>
          {onAbandon && (
            <IconButton onClick={onAbandon}>
              <Icon icon="iconsTrashCanSvg" alt="Trash" />
            </IconButton>
          )}
        </div>
      )}
    </div>
  );
};

const CancelLink = styled.button`
  margin-left: auto;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: ${colors.grey.dark};
  cursor: pointer;
`;

const ProgressContainer = styled.div`
  border-radius: 12px;
  background: ${colors.grey.disabledBackground};
`;

const Progress = styled.div<{ progress: number }>`
  height: 100%;
  min-height: 4px;
  width: ${({ progress }) => `${progress}%`};
  background-color: ${colors.green};
  border-radius: inherit;
`;
